<div class="container-fluid text-center">
  <div class="col-sm-8 text-start">
    <h2>{{ 'patient-diary.diaries' | translate }}</h2>
    <hr />
  </div>

  <section
    *ngIf="isManager && (showOnlyOwnDiaryInstances || (pagedInstanceDiaryPair$ | async).length > 0)"
  >
    <mat-checkbox
      [attr.id]="'checkboxShowOnlyOwnDiaryInstances'"
      [(ngModel)]="showOnlyOwnDiaryInstances"
      (change)="loadData()"
    >
      {{ 'intervention-instance.show_only_own_diary_instances' | translate }}
    </mat-checkbox>
  </section>

  <app-pagination-list
    #paginator
    (emitPageChange)="updatePagedDiaryInstances($event)"
    [_isLoading]="isLoading$ | async"
    [_items]="instanceDiaryPairs$ | async"
  ></app-pagination-list>

  <div class="row justify-content-center">
    <div *ngIf="(isLoading$ | async); else elseInterventionBlock" class="col-sm">
      <app-loader></app-loader>
    </div>

    <ng-template #elseInterventionBlock>
      <div
        *ngFor="let content of (pagedInstanceDiaryPair$ | async); trackBy: trackByDiaryInstance"
        class="col-12 col-lg-6 d-flex justify-content-center"
      >
        <app-card-diary
          [_users]="studyMembers"
          [_diary]="content.diary"
          [_diaryInstance]="content.diary_instance"
          [_isManager]="isManager"
        ></app-card-diary>
      </div>
    </ng-template>
  </div>
</div>
